export const API_URL_USERS = `${import.meta.env.VITE_API_BASE_URL}users`;
export const API_URL_COMPANION = `${import.meta.env.VITE_API_BASE_URL}companion`;
export const API_URL_DEVICES = `${import.meta.env.VITE_API_BASE_URL}devices`;
export const API_URL_OBJECTIVES = `${import.meta.env.VITE_API_BASE_URL}objectives`;
export const API_URL_AUTH = `${import.meta.env.VITE_API_BASE_URL}auth`; // `${import.meta.env.VITE_API_BASE_URL}auth`;
export const API_URL_GOOGLE = `${import.meta.env.VITE_API_BASE_URL}google-api`; // `${import.meta.env.VITE_API_BASE_URL}auth`;
export const API_URL_APPLE = `${import.meta.env.VITE_API_BASE_URL}apple-api`; // `${import.meta.env.VITE_API_BASE_URL}auth`;
export const API_URL_MICROSOFT = `${
  import.meta.env.VITE_API_BASE_URL
}microsoft-api`; // `${import.meta.env.VITE_API_BASE_URL}auth`;

export type AvailableAPIProvidersType = "google" | "microsoft" | "apple"; // Extend as needed
